export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result))
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(blob)
  })
}

export async function prepareWhatsAppPhoto(photo: Blob, qrToken: string): Promise<Blob> {
  const { default: QRCode } = await import('qrcode')
  const canvas = document.createElement('canvas')
  canvas.width = 1200
  canvas.height = 628
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas is unavailable')

  const bitmap = await createImageBitmap(photo)
  const photoWidth = 810
  const scale = Math.max(photoWidth / bitmap.width, canvas.height / bitmap.height)
  const width = bitmap.width * scale
  const height = bitmap.height * scale
  ctx.drawImage(bitmap, (photoWidth - width) / 2, (canvas.height - height) / 2, width, height)
  bitmap.close()

  ctx.fillStyle = '#f0eadc'
  ctx.fillRect(photoWidth, 0, canvas.width - photoWidth, canvas.height)
  ctx.fillStyle = '#121611'
  ctx.font = '700 42px system-ui, sans-serif'
  ctx.textAlign = 'center'
  ctx.fillText('GATEPASS', 1005, 74)
  ctx.font = '600 24px system-ui, sans-serif'
  ctx.fillText('SCAN AT EXIT', 1005, 120)

  const qrDataUrl = await QRCode.toDataURL(qrToken, { margin: 1, width: 300, color: { dark: '#121611', light: '#f0eadc' } })
  const qrImage = new Image()
  qrImage.src = qrDataUrl
  await qrImage.decode()
  ctx.drawImage(qrImage, 855, 160, 300, 300)
  ctx.font = '500 20px ui-monospace, monospace'
  ctx.fillText('KEEP THIS PASS READY', 1005, 520)

  return new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Could not create pass image')), 'image/jpeg', 0.9))
}
